import { useLocalStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export interface TutorialEntry {
  id: string
  thumbnail_url: string
  video_embed_url: string
  title: string
  description: string
  new?: boolean
}

export const useTutorialStore = defineStore('tutorial', () => {
  const tutorialReaded = useLocalStorage<string[]>('tutorial-readed', [])

  const tutorials = ref<TutorialEntry[]>([
    {
      id: 'tutorial-1',
      thumbnail_url: '/tutorial-thumbnail-4.jpg',
      video_embed_url:
        'https://www.loom.com/embed/ab5620acea1043be93be1b99be5501c4?sid=a8a13a05-b27c-4b40-b918-7cc6fbb6cafe',
      title: 'Cases',
      description:
        'Chat with a Concierge model that can delegate specialized tasks to your agents.',
      new: !tutorialReaded.value.includes('Cases'),
    },
    {
      id: 'tutorial-2',
      thumbnail_url: '/tutorial-thumbnail-1.jpg',
      video_embed_url:
        'https://www.loom.com/embed/8b8b091ca34e4284accc563e3a69f130?sid=3d2d0107-6b56-4a61-a305-adbc33bb0ec6',
      title: 'Basic Properties',
      description: 'Learn how to configure a property that runs an AI model on your data.',
      new: !tutorialReaded.value.includes('Basic Properties'),
    },
    {
      id: 'tutorial-3',
      thumbnail_url: '/tutorial-thumbnail-2.jpg',
      video_embed_url:
        'https://www.loom.com/embed/d3305090b184456896118dd89381b6dc?sid=6e96dc7d-a0bb-49d0-9645-6032731259ca',
      title: 'Advanced Properties',
      description: 'Learn how to use Single Selects, and Collections for tabular data extraction.',
      new: !tutorialReaded.value.includes('Advanced Properties'),
    },
    {
      id: 'tutorial-4',
      thumbnail_url: '/tutorial-thumbnail-3.jpg',
      video_embed_url:
        'https://www.loom.com/embed/29e4076ca24d4b16a352ef6bc6b1d488?sid=f01a3831-d73e-4179-831e-949dee1d62d9',
      title: 'Workflows',
      description:
        'Learn how to trigger extra AI steps for files passing or failing custom criteria.',
      new: !tutorialReaded.value.includes('Workflows'),
    },
  ])
  const activeTutorialId = ref<string | null>(null)

  const hasNewTutorials = computed(() => {
    return tutorials.value.some((entry) => entry.new)
  })

  const markTutorialReadState = (title: string, value = false) => {
    tutorials.value = tutorials.value.map((entry) =>
      entry.title === title ? { ...entry, new: !value } : entry,
    )

    if (!value) {
      return
    }

    const updatedReadList = [...tutorialReaded.value, title]
    tutorialReaded.value = updatedReadList
    localStorage.setItem('tutorial-readed', JSON.stringify(updatedReadList))
  }

  const setActiveTutorial = (tutorialId: string) => {
    activeTutorialId.value = tutorialId
  }

  return {
    tutorials,
    activeTutorialId,
    hasNewTutorials,
    markTutorialReadState,
    setActiveTutorial,
  }
})
